export { CorporativoBusinessBankingCredentialsWeb } from "./CorporativoBusinessBankingCredentialsWeb";
